import React, { FC } from 'react';
import Modal from '@minecraft.modal';
import { useTranslation } from '@blocs.i18n';
import { Loader } from '@minecraft.atoms';
import { getEnvironment } from '@minecraft.environment';
import { useExternalScript } from '@minecraft.utils';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import PaymentMethodsManager from '../PaymentMethodsManager';

type Props = {
  isOpen: boolean;
  handleToggleClick: () => void;
};

const AddCardModal: FC<Props> = ({ isOpen, handleToggleClick }) => {
  const { t } = useTranslation();

  const config = getEnvironment();
  const billingPlatformPublicKey = config['RECURLY_PUBLIC_KEY'];
  const [externalScriptLoaded, loadBillingScriptError] = useExternalScript('https://js.recurly.com/v4/recurly.js');

  return (
    isOpen && (
      <Modal isOpen handleToggleClick={handleToggleClick} modalSize="small" isFooterHidden noPadding>
        <Loader
          loading={(!externalScriptLoaded && !loadBillingScriptError) || !window.recurly}
          error={loadBillingScriptError && t('common:globalErrors.generic')}
        >
          <RecurlyProvider publicKey={billingPlatformPublicKey} required={['cvv', 'postal_code']}>
            <Elements>
              <PaymentMethodsManager isUpdateBillingInfo isAddModal showFormBorder onCardAdded={handleToggleClick} />
            </Elements>
          </RecurlyProvider>
        </Loader>
      </Modal>
    )
  );
};

export default AddCardModal;
